module.exports = __webpack_public_path__ + "static/Gilroy-Regular-2abef08d922206ae58ff5e8f75015547.woff";